import axios from "axios";
import { Config } from "../../../core/config/config";
import { processLoadOptions } from "@/core/helper/datasource-query-helper";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/account/admin/parameter`;

export const parameterService = {
    getParameter: async function (id: any) {
        return axios.get(`${GATEWAY_URL}/get-parameter`, {
            params: { id }
        })
        .then((response) => {
            return response.data;
        });
    },
    getParameterTranslate: async function (parameterId: any) {
        return axios.get(`${GATEWAY_URL}/get-parameter-translate`, {
            params: { parameterId }
        })
        .then((response) => {
            return response.data;
        });
    },
    getParentParameters: async function (loadOptions:any) {
        const params = processLoadOptions(loadOptions);
        return axios.get(`${GATEWAY_URL}/get-parent-parameters`,{
            params
        })
        .then((response) => {
            return response.data;
        });
    },
    createParameter: async function (params: any) {
        return axios.post(`${GATEWAY_URL}/create-parameter`, params)
        .then((response) => {
            return response.data;
        });
    },
    updateParameter: async function (key:any, params: any) {
        return axios.put(`${GATEWAY_URL}/update-parameter`, params)
        .then((response) => {
            return response.data;
        });
    },
    deleteParameter: async function (params: any) {
        return axios.delete(`${GATEWAY_URL}/delete-parameter`, {
            params
        })
        .then((response) => {
            return response.data;
        });
    },
    getParameterByCode: async function (code: any) {
        return axios.get(`${GATEWAY_URL}/get-parameter-by-code`, {
            params: { code }
        })
        .then((response) => {
            return response.data;
        });
    },
}
